import { Redirect } from 'react-router-dom';

import WeeklyReportTable from '../../components/WeeklyReportTable/WeeklyReportTable';
import { checkRol } from '../../security';
import { aprobador } from '../../security/constantsRols';

const ApproverWeeklyWorkReport = () => {
  const isApprover = checkRol(aprobador);

  if (!isApprover) return <Redirect to="/" />;

  return <WeeklyReportTable />;
};

export default ApproverWeeklyWorkReport;
